import { Link } from 'react-router-dom'
import SectionLabel from './SectionLabel'
import DepartureRow from './DepartureRow'
import { departures } from '../data/departures'

export default function DeparturesPreview() {
  const previews = departures.slice(0, 3)

  return (
    <section className="section" style={{ background: 'var(--white)' }}>
      <SectionLabel>Upcoming Departures</SectionLabel>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-end', 
        gap: '32px', 
        marginBottom: '20px',
        flexWrap: 'wrap'
      }}>
        <div>
          <h2 className="section-title">Join a small group.</h2>
          <p className="section-sub" style={{ margin: 0 }}>
            Small groups of 2–6 explorers. All dates guaranteed. Direct booking via WhatsApp.
          </p>
        </div>
        <Link to="/departures" className="btn" style={{ 
          fontSize: '13px',
          fontWeight: 600,
          color: 'var(--green)',
          textDecoration: 'underline'
        }}>
          View All Dates →
        </Link>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
        {previews.map(d => (
          <DepartureRow key={d.id} dep={d} />
        ))}
      </div>
    </section>
  )
}
